// Thin fetch wrapper that automatically:
// - Prefixes requests with REACT_APP_BACKEND_URL
// - Adds Bearer token from localStorage (auth_token)
// - Parses JSON responses and normalizes API errors into an Error with a Serbian message

const BASE = process.env.REACT_APP_BACKEND_URL;

const readError = (detail) => {
  if (!detail) return "Greška na serveru";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && detail.msg) return detail.msg;
  return String(detail);
};

export const getToken = () => localStorage.getItem("auth_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("auth_token", t);
  else localStorage.removeItem("auth_token");
};

export async function apiFetch(path, { method = "GET", body, headers = {} } = {}) {
  const token = getToken();
  const opts = {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  const text = await res.text();
  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { detail: text };
    }
  }
  if (!res.ok) {
    const err = new Error(readError(data?.detail));
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// Convenience wrappers
export const api = {
  get: (p) => apiFetch(p),
  post: (p, body) => apiFetch(p, { method: "POST", body }),
  patch: (p, body) => apiFetch(p, { method: "PATCH", body }),
  del: (p) => apiFetch(p, { method: "DELETE" }),
  upload: async (p, formData) => {
    const token = getToken();
    const res = await fetch(`${BASE}${p}`, {
      method: "POST",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });
    const text = await res.text();
    let data = null;
    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = { detail: text };
      }
    }
    if (!res.ok) {
      const err = new Error(readError(data?.detail));
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  },
};
